import React from "react";
import "./About.css";
import Footer from "../../components/Footer/Footer";

export default function About({ navigate, showComingSoon }) {
  return (
    <>
      {/* Hero */}
      <div className="about-hero">
        <div className="about-hero-inner">
          <div className="big-icon">🏢</div>
          <h1>About RoadDogg AI</h1>
          <p>
            RoadDogg AI is a product of Kustom Habitz LLC — built to make every
            journey smarter, safer, and more connected.
          </p>
        </div>
      </div>

      <div className="about-body">
        <div className="about-inner">
          {/* Company identity card — the key block Apple needs to see */}
          <div className="company-card">
            <div className="company-card-icon">🏛️</div>
            <div className="company-card-text">
              <h2>Developed &amp; Operated by Kustom Habitz LLC</h2>
              <p>
                RoadDogg AI is a mobile application developed, published, and
                operated by <strong>Kustom Habitz LLC</strong>. All app
                services, support, and data practices described on this website
                are the responsibility of Kustom Habitz LLC.
              </p>
              <span className="legal-name">Kustom Habitz LLC</span>
            </div>
          </div>

          {/* Who we are */}
          <h2>Who We Are</h2>
          <p>
            Kustom Habitz LLC is the company behind RoadDogg AI. We are
            dedicated to building intelligent, practical mobile tools that help
            people navigate their daily lives with greater confidence and ease.
          </p>
          <p>
            RoadDogg AI is our flagship product — an AI-powered co-pilot app
            available on iOS and Android that combines a smart AI assistant,
            real-time maps, activity logging, weather, and more into one clean,
            intuitive experience.
          </p>

          {/* What is RoadDogg AI */}
          <h2>What Is RoadDogg AI?</h2>
          <p>
            RoadDogg AI is a smart companion app designed for everyday users —
            drivers, travelers, commuters, and anyone who wants an intelligent
            assistant in their pocket. The app brings together:
          </p>
          <ul style={{ paddingLeft: "20px", marginBottom: "14px" }}>
            <li
              style={{
                fontSize: "15px",
                color: "#555",
                lineHeight: 1.75,
                marginBottom: "6px",
              }}
            >
              An AI voice and text assistant for real-time help on the go
            </li>
            <li
              style={{
                fontSize: "15px",
                color: "#555",
                lineHeight: 1.75,
                marginBottom: "6px",
              }}
            >
              Smart map filters for gas, food, parking, and points of interest
            </li>
            <li
              style={{
                fontSize: "15px",
                color: "#555",
                lineHeight: 1.75,
                marginBottom: "6px",
              }}
            >
              Activity and expense logging with a built-in digital file cabinet
            </li>
            <li
              style={{
                fontSize: "15px",
                color: "#555",
                lineHeight: 1.75,
                marginBottom: "6px",
              }}
            >
              Live weather conditions and radar for any location
            </li>
            <li
              style={{
                fontSize: "15px",
                color: "#555",
                lineHeight: 1.75,
                marginBottom: "6px",
              }}
            >
              Privacy-first design with built-in App Lock
            </li>
          </ul>

          {/* Legal operator section */}
          <h2>Legal &amp; Compliance</h2>
          <p>
            RoadDogg AI is published on the Apple App Store and Google Play
            Store under <strong>Kustom Habitz LLC</strong>. All terms of
            service, privacy policies, and data practices referenced throughout
            this website apply to services provided by Kustom Habitz LLC.
          </p>
          <p>
            Our Privacy Policy and Terms &amp; Conditions are available on this
            website and within the app. For any legal inquiries, please contact
            us directly using the information below.
          </p>

          {/* Contact block */}
          <div className="about-contact-block">
            <h3>Contact &amp; Support</h3>
            <div className="about-contact-row">
              <span className="acr-label">Company</span>
              <span className="acr-value">Kustom Habitz LLC</span>
            </div>
            <div className="about-contact-row">
              <span className="acr-label">Product</span>
              <span className="acr-value">RoadDogg AI</span>
            </div>
            <div className="about-contact-row">
              <span className="acr-label">Email</span>
              <span className="acr-value">
                <a href="mailto:kustomhabitzz@gmail.com">
                  kustomhabitzz@gmail.com
                </a>
              </span>
            </div>
            <div className="about-contact-row">
              <span className="acr-label">Website</span>
              <span className="acr-value">
                <a
                  onClick={() => navigate("support")}
                  style={{ cursor: "pointer" }}
                >
                  roaddoggai.com/support
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>

      <Footer navigate={navigate} showComingSoon={showComingSoon} />
    </>
  );
}
